export default "/images/uploaded.jpg?3dd5a1e7917a629db79d060028034549";